export default __webpack_public_path__ + "static/media/privacy-policy-kr-5.b6632a47.jpg";